import { render, staticRenderFns } from "./addrDialog.vue?vue&type=template&id=d1573d0c&scoped=true"
import script from "./addrDialog.vue?vue&type=script&lang=js"
export * from "./addrDialog.vue?vue&type=script&lang=js"
import style0 from "./addrDialog.vue?vue&type=style&index=0&id=d1573d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1573d0c",
  null
  
)

export default component.exports